import React from "react";
import { Card } from "react-bootstrap";
import BrandDisplay from "../../NewsFeed/BrandDisplay";
import formatPrice from "../../lib/formatPrice";
import { Link } from "react-router-dom";
import ColorSelector from "../../Experiments/colorDisplay";
import AddToList from "../../components/AddToList";
import AddOrRemoveLike from "../../Products/AddOrRemoveLike";
import AddToCart from "../../components/AddToCart";

const ProductCardExpanded = ({ product, brandData, handleClick,user,setLikeCount }) => {
  return (
    <div className="m-1 m-sm-1 expanded-card shadow-sm rounded">
      <Card onClick={handleClick} className="position-relative border-0">
        <div className="d-flex flex-row">
          <div
            style={{
              position: "relative",
              height: "380px",
              width: "290px",
              overflow: "hidden",
            }}
          >
            <Card.Img
              src={product.imageUrl}
              style={{
                height: "100%",
                objectFit: "cover",
                cursor: "pointer",
                borderTopLeftRadius: "0.475rem",
                borderBottomLeftRadius: "0.475rem",
                borderRadius: '0.5rem',
                padding: '8px',
              }}
              loading="lazy"
            />
          </div>

          <div
            className="p-2"
            style={{
              flex: 1,
              marginLeft: "2px",
              maxHeight: "380px",
              overflowY: "auto",
              overflowX: "hidden",
              fontSize: "14px",
              lineHeight: "1.4",
              color: "#555",
              scrollbarWidth: "thin",
              scrollbarColor: "#888 #f1f1f1",
            }}
          >
            <div style={{ paddingRight: "10px" }}>
              <div>
                {/* Brand Name */}
                <div className="mb-1 small " style={{ fontSize: "14px" }}>
                  {brandData?.displayName}
                </div>

                {/* Product Name */}
                <div className="mb-1 fw-bold" style={{ fontSize: "22px" }}>
                  {product?.name}
                </div>

                {/* Price */}
                <div className="text-danger fw-bold" style={{ fontSize: "18px" }}>
                  PKR {formatPrice(product?.newPrice)}
                </div>
              </div>


              <div className="d-flex align-items-center mb-2">
                {product?.oldPrice > 0 && (
                  <strike className="text-body small me-2">
                    PKR {formatPrice(product?.oldPrice)}
                  </strike>
                )}
                {product?.discount > 0 && (
                  <span className="badge rounded-pill bg-warning p-1 small">
                    {product?.discount}% OFF
                  </span>
                )}
              </div>
              {/* Color Section */}
              {product?.colors.length > 0 && (
                <div className="mt-1">
                 
                  <div className="d-flex flex-wrap my-1">
                    {product?.colors?.length > 0 && (
                      <ColorSelector colors={product?.colors} width="20px" height="20px" />
                    )}
                  </div>
                </div>
              )}
              {/* Size Section */}
              {product?.sizes && product.sizes.length > 0 && (
                <div className="mb-2">
                  <div className="d-flex flex-wrap">
                    {product.sizes.map((size, index) => (
                      <span
                        key={index}
                        className="badge  text-dark me-2 mb-1"
                        style={{
                          border: '3px ',
                          padding: '4px 18px',
                          fontSize: '15px',
                          backgroundColor:'#CDD5E3'
                        }}
                      >
                        {size}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {/* <hr className="my-2" /> */}

              <div
                dangerouslySetInnerHTML={{ __html: product?.description }}
                style={{
                  wordWrap: "break-word",
                  fontSize: "13px",
                }}
              />


            </div>
            <div className="Buttons d-flex flex-row flex-wrap align-items-center  gap-2">
                <div
                  style={{ width: "16rem", height: "2.1rem" }}
                  className="btn btn-primary rounded p-1 d-flex justify-content-center align-items-center"
                >
                  <AddToList product={product} componentName={"productDetails"} />
                </div>
                <div
                  style={{ width: "2.3rem", height: "2.3rem" }}
                  className="icon-xs text-white rounded-circle border border-secondary"
                >
                  <AddOrRemoveLike
                    user={user}
                    product={product}
                    setLikeCount={setLikeCount}
                    componentName={"strip2"}
                  />
                </div>
                <div
                  style={{ width: "2.3rem", height: "2.3rem" }}
                  className="icon-xs text-white rounded-circle border border-secondary"
                >
                  <AddToCart
                    user={user}
                    product={product}
                    componentName={"ShopListProdCard"}
                  />
                </div>
              </div>
          </div>
        </div>
        
      </Card>
   
      {/* <div className="ps-1 pb-1 pt-1">
        <div className="d-flex align-items-center">

          <div
            className="avatar me-2"
            style={{ width: "35px", height: "35px" }}
          >
            <Link to={"/BrandHome/" + product?.supplier}>
              <img
                className="avatar-img rounded"
                src={brandData?.logoUrl}
                alt=""
              />
            </Link>
          </div>
          <div
            className="d-flex flex-column justify-content-start"
            style={{ width: "78%" }}
          >
            <div className="mb-0">
              <BrandDisplay brandData={brandData} type={"ProductCard"} />
            </div>
            <Link 
              className="small text-muted" 
              to={`/ProductDetails/${product?.id}`}
              style={{ textDecoration: 'none' }}
            >
              View all details
            </Link>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default ProductCardExpanded;